var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtworkMgt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32666 16.6478L6.8867 11.0878M13.8883 8.61527L12.224 13.6083C12.1974 13.6883 12.1519 13.7608 12.0914 13.8195C12.0309 13.8782 11.957 13.9214 11.8762 13.9455L1.67351 16.9781C1.58159 17.0054 1.48394 17.0069 1.3912 16.9826C1.29845 16.9582 1.21416 16.9089 1.14749 16.84C1.08082 16.7711 1.03434 16.6852 1.01309 16.5917C0.991845 16.4982 0.996652 16.4007 1.02699 16.3097L4.33995 6.37256C4.36369 6.30121 4.40251 6.23581 4.45376 6.18078C4.50502 6.12576 4.56751 6.08241 4.637 6.05367L9.34346 4.11587C9.43915 4.07635 9.54439 4.06605 9.64592 4.08626C9.74745 4.10647 9.84072 4.1563 9.91397 4.22944L13.7616 8.07797C13.8306 8.14688 13.879 8.23367 13.9014 8.32859C13.9238 8.42351 13.9193 8.52279 13.8883 8.61527V8.61527Z",
    stroke: "url(#paint0_linear_421_1777)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9913 8.30832L16.4621 5.83671C16.7897 5.50903 16.9737 5.06467 16.9737 4.60134C16.9737 4.138 16.7897 3.69364 16.4621 3.36597L14.6099 1.51203C14.4476 1.3497 14.255 1.22093 14.0429 1.13308C13.8309 1.04522 13.6036 1 13.3741 1C13.1446 1 12.9173 1.04522 12.7053 1.13308C12.4932 1.22093 12.3006 1.3497 12.1383 1.51203L9.66755 3.98365M8.73971 9.23441C8.61798 9.11274 8.47347 9.01623 8.31445 8.95041C8.15542 8.88458 7.98498 8.85072 7.81287 8.85076C7.64076 8.8508 7.47034 8.88474 7.31134 8.95064C7.15235 9.01655 7.00789 9.11312 6.88622 9.23485C6.76454 9.35658 6.66804 9.50108 6.60221 9.66011C6.53638 9.81914 6.50252 9.98958 6.50256 10.1617C6.5026 10.3338 6.53654 10.5042 6.60245 10.6632C6.66835 10.8222 6.76492 10.9667 6.88665 11.0883C7.1325 11.3341 7.46589 11.4721 7.81349 11.472C8.16109 11.4719 8.49442 11.3338 8.74015 11.0879C8.98588 10.8421 9.12388 10.5087 9.1238 10.1611C9.12372 9.81347 8.98556 9.48014 8.73971 9.23441Z",
    stroke: "url(#paint1_linear_421_1777)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_1777",
    x1: 7.45773,
    y1: 4.07617,
    x2: 7.45773,
    y2: 16.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_1777",
    x1: 11.7381,
    y1: 1,
    x2: 11.7381,
    y2: 11.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtworkMgt);
export default __webpack_public_path__ + "static/media/ArtworkMgt.a05e0ee47763516668ea6f16baebdd66.svg";
export { ForwardRef as ReactComponent };